import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5 8h14v10H5z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
})), 'WebAssetTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/WebAssetTwoTone.js
// module id = 7250
// module chunks = 2